import { Col, Nav } from "react-bootstrap";

export const ProductCardB = ({ title, description, imgUrl, link }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} alt=''/>
        <div className="proj-txtx">
          <h5>{title}</h5>
          <span>{description}</span><br /><br />
          <Nav.Link href={link} rel="noreferrer" target='_blank'><h5>SEE PRICE / ORDER NOW!</h5></Nav.Link>
        </div>
      </div>
    </Col>
  )
}
